// extracted by mini-css-extract-plugin
module.exports = {"scau9yq":"scau9yq","sizeBadge":"sizeBadge","bigIcon":"bigIcon","sizeS":"sizeS","sizeM":"sizeM","sizeL":"sizeL"};